import React, { SVGProps } from 'react'
const SvgInviteGuest = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={93}
    height={90}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#InviteGuest_svg__a)">
      <ellipse cx={46.87} cy={43.322} fill="#F2F3F7" rx={39.997} ry={38.933} />
    </g>
    <mask
      id="InviteGuest_svg__b"
      width={82}
      height={81}
      x={6}
      y={2}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <ellipse cx={46.923} cy={42.627} fill="#fff" rx={40.254} ry={39.627} />
    </mask>
    <g mask="url(#InviteGuest_svg__b)">
      <g filter="url(#InviteGuest_svg__c)">
        <path
          fill="url(#InviteGuest_svg__d)"
          fillRule="evenodd"
          d="M-1.805 86.47s-6.18-27.668 18.538-27.668c24.717 0 18.538 27.667 18.538 27.667"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#InviteGuest_svg__e)">
        <ellipse cx={16.733} cy={49.831} fill="#fff" rx={11.864} ry={11.882} />
        <ellipse
          cx={16.733}
          cy={49.831}
          fill="url(#InviteGuest_svg__f)"
          fillOpacity={0.6}
          rx={11.864}
          ry={11.882}
        />
      </g>
      <g filter="url(#InviteGuest_svg__g)">
        <path
          fill="#BDC1C8"
          fillRule="evenodd"
          d="M66.152 75.51S61.74 55.771 79.394 55.771 92.635 75.51 92.635 75.51"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#InviteGuest_svg__h)">
        <ellipse cx={79.392} cy={49.681} fill="#D8DADE" rx={8.475} ry={8.477} />
      </g>
      <g
        fillRule="evenodd"
        clipRule="evenodd"
        filter="url(#InviteGuest_svg__i)"
      >
        <path
          fill="#fff"
          d="M21.528 96.587s-8.587-38.636 25.76-38.636c34.348 0 25.761 38.636 25.761 38.636"
        />
        <path
          fill="url(#InviteGuest_svg__j)"
          fillOpacity={0.6}
          d="M21.528 96.587s-8.587-38.636 25.76-38.636c34.348 0 25.761 38.636 25.761 38.636"
        />
      </g>
      <g filter="url(#InviteGuest_svg__k)">
        <ellipse
          cx={47.442}
          cy={47.426}
          fill="url(#InviteGuest_svg__l)"
          rx={16.487}
          ry={16.593}
        />
      </g>
    </g>
    <defs>
      <filter
        id="InviteGuest_svg__a"
        width={91.858}
        height={89.731}
        x={0.941}
        y={0.151}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.695} />
        <feGaussianBlur stdDeviation={2.966} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__c"
        width={46.925}
        height={36.142}
        x={-6.729}
        y={56.26}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.695} />
        <feGaussianBlur stdDeviation={2.119} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__e"
        width={32.203}
        height={32.239}
        x={0.631}
        y={35.407}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.695} />
        <feGaussianBlur stdDeviation={2.119} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__g"
        width={34.243}
        height={26.518}
        x={62.272}
        y={53.229}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.847} />
        <feGaussianBlur stdDeviation={1.695} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__h"
        width={23.729}
        height={23.734}
        x={67.528}
        y={38.662}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.847} />
        <feGaussianBlur stdDeviation={1.695} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__i"
        width={61.904}
        height={47.111}
        x={16.337}
        y={55.408}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.695} />
        <feGaussianBlur stdDeviation={2.119} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <filter
        id="InviteGuest_svg__k"
        width={41.448}
        height={41.661}
        x={26.718}
        y={28.291}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.695} />
        <feGaussianBlur stdDeviation={2.119} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12943_3281"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12943_3281"
          result="shape"
        />
      </filter>
      <linearGradient
        id="InviteGuest_svg__d"
        x1={9.733}
        x2={16.616}
        y1={29.524}
        y2={129.191}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#443FDD" />
        <stop offset={1} stopColor="#9387FC" />
      </linearGradient>
      <linearGradient
        id="InviteGuest_svg__f"
        x1={14.729}
        x2={22.206}
        y1={24.419}
        y2={93.688}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#443FDD" />
        <stop offset={1} stopColor="#9387FC" />
      </linearGradient>
      <linearGradient
        id="InviteGuest_svg__j"
        x1={53.663}
        x2={59.084}
        y1={-36.028}
        y2={95.342}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AF2" />
        <stop offset={1} stopColor="#5FCEB6" />
      </linearGradient>
      <linearGradient
        id="InviteGuest_svg__l"
        x1={58.787}
        x2={49.323}
        y1={4.263}
        y2={64.018}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AF2" />
        <stop offset={1} stopColor="#5FCEB6" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgInviteGuest
